<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M31.5227 24.7352C31.5227 29.858 27.7393 34.7756 20.6364 34.7756C13.5334 34.7756 9.75 29.858 9.75 24.7352C9.75 20.6199 10.7529 16.4194 12.6374 13.2738C14.5167 10.1368 17.2148 8.125 20.6364 8.125C24.0527 8.125 26.7519 10.1699 28.6343 13.3308C30.5206 16.498 31.5227 20.6999 31.5227 24.7352Z" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
